<template>
  <el-tabs
    v-if="pickup.previous_pickup"
    v-model="activeTab"
    tab-position="top"
  >
    <el-tab-pane
      label="Current Pickup"
      :name="pickup.id"
      class="p-0"
    >
      <Notes
        :resource="pickup"
        truncate
        paginate
        pagination-layout="prev, pager, next"
        :limit="3"
      />
    </el-tab-pane>

    <el-tab-pane
      v-for="(previousPickup, index) in previousPickups"
      :key="index"
      :label="(index === previousPickups.length - 1) ? 'Original Pickup' : previousPickup.booking_reference"
      :name="previousPickup.id"
      class="p-0"
    >
      <Notes
        :resource="previousPickup"
        truncate
        paginate
        pagination-layout="prev, pager, next"
        :limit="3"
      />
    </el-tab-pane>
  </el-tabs>

  <Notes
    v-else
    :resource="pickup"
    truncate
    paginate
    pagination-layout="prev, pager, next"
    :limit="3"
  />
</template>

<script>
import Notes from '@/components/Notes'
import { CREATED } from '@/plugins/sdk/Events'

export default {
  components: {
    Notes
  },
  props: {
    pickup: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      activeTab: undefined
    }
  },
  computed: {
    previousPickups () {
      const previousPickups = []
      let pickup = this.pickup

      while (pickup.previous_pickup instanceof this.$sdk.pickup) {
        previousPickups.push(pickup.previous_pickup)
        pickup = pickup.previous_pickup
      }

      return previousPickups
    }
  },
  created () {
    this.activeTab = this.pickup.id
  },
  mounted () {
    this
      .$sdk
      .note
      .on(CREATED, () => {
        this.activeTab = this.pickup.id
      }, this)
  }
}
</script>
